<nav mat-tab-nav-bar class="admin-tabs" *ngIf="tabs.length > 1" [tabPanel]="adminPanel" mat-stretch-tabs="false"
  aria-label="Verwaltung">
  <a mat-tab-link *ngFor="let tab of tabs" [routerLink]="tab.path" routerLinkActive #rla="routerLinkActive"
    [active]="rla.isActive">
    <mat-icon>{{ tab.icon }}</mat-icon>
    {{ tab.label }}
  </a>
</nav>
<mat-tab-nav-panel #adminPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
